export const updateUi = payload => ({ type: 'UPDATE_UI', payload })

// side panel
export const openSidePanelPopOver = () => (updateUi({ sidePanelPopOver: { visible: true } }))
export const closeSidePanelPopOver = () => (updateUi({ sidePanelPopOver: { visible: false } }))